import { render, staticRenderFns } from "./NotificationsDay.vue?vue&type=template&id=093ab910&"
import script from "./NotificationsDay.vue?vue&type=script&lang=js&"
export * from "./NotificationsDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports